// @flow
import { styled } from 'mz-ui-kit'

export const InputContainer = styled('div', {
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  maxWidth: '100%',
})

export const NativeInput = styled('input', {
  opacity: 0,
  position: 'absolute',
  border: 0,
  top: 0,
  left: 0,
  bottom: 0,
  width: '100vw',
  maxWidth: '100%',
  WebkitTapHighlightColor: 'transparent',
  boxSizing: 'border-box',
})
